
<template>
  <content-box class="plan-subscription--wrap" :width="'1018px'" :class="planType">
    <p class="title">
      <template v-if="!planData.canCreate">{{ $t('common.planSubscription') }}</template>
      <template v-else>{{ $t('common.changePlan') }}</template>
    </p>
    <p class="desc">{{ $t('userInfo.managePlan.planSubscription.desc') }}</p>

    <div class="template-pricing">
      <div class="contents">
          <div class="options">
              <div class="option">
                  <span class="option-title english-font">{{ $t('plan.pricing.free.title') }}</span>
                  <i class="option-main-image free" alt="" />
                  <span class="option-pv" v-html="$t('plan.pricing.free.pv')"></span>
                  <span class="option-price" :class="{'system-font': isMac}">{{ $t('plan.pricing.free.price') }}</span>
                  <ui-button
                  class="option-btn"
                  :class="{'system-font': isMac}"
                  style="margin-top: 20px"
                  :primary="true"
                  :disabled="!canChangePlan(0)"
                  @click="onSelectPlan(0)">
                    <template v-if="isInUsePlan(0)">
                      {{ $t('common.inUse') }}
                    </template>
                    <template v-else>{{ $t('common.useExpired') }}</template>
                  </ui-button>
              </div>

              <div class="option recommend saas">
                  <i class="option-recommend-image" :class="$i18n.locale" alt="" />
                  <span class="option-title english-font">
                      {{ $t('plan.pricing.saas.title') }}
                      <span class="sub english-font">{{ saasDetail }}</span>
                  </span>
                  <i class="option-main-image saas" alt="" />
                  <select class="option-pv-select" @change="onChangePvOption($event)">
                    <template v-for="(item, index) in saasPv">
                      <option :value="item.value" :key="index">{{ item.label }}</option>
                    </template>
                  </select>
                  <span class="option-price" :class="{'system-font': isMac}" v-html="saasPrice"></span>
                  <ui-button
                  class="option-btn"
                  :class="{'system-font': isMac}"
                  style="margin-top: 20px"
                  :primary="true"
                  :disabled="!canChangePlan(saasPlanNumber)"
                  @click="onSelectPlan( 'saas', saasPlanNumber)">
                    <template v-if="isInUsePlan(saasPlanNumber)">
                      {{ $t('common.inUse') }}
                    </template>
                    <template v-else>{{ $t('plan.pricing.saas.select') }}</template>
                  </ui-button>
              </div>

              <div class="option">
                  <span class="option-title english-font" :class="{'system-font': isMac}">
                    {{ $t('plan.pricing.enterprise.title') }}
                    <span class="sub english-font">{{ enterpriseDetail }}</span>
                  </span>
                  <i class="option-main-image enterprise" alt="" />
<!--                  <span class="option-pv" v-html="$t('plan.pricing.enterprise.pv')"></span>-->
                  <select class="option-pv-select" @change="onChangeEnterprisePvOption($event)">
                    <template v-for="(item, index) in enterprisePv">
                      <option :value="item.value" :key="index">{{ item.label }}</option>
                    </template>
                  </select>
                <span class="option-price" :class="{'system-font': isMac}" v-html="enterprisePrice"></span>
                  <ui-button
                  class="option-btn"
                  :class="{'system-font': isMac}"
                  style="margin-top: 20px"
                  :primary="true"
                  @click="onSelectPlan('enterprise', enterprisePlanNumber)">
                    <template v-if="isInUsePlan(enterprisePlanNumber)">
                      {{ $t('common.inUse') }}
                    </template>
                    <template v-else>
                      {{ $t('plan.pricing.saas.select') }}
                    </template>
                  </ui-button>
              </div>
          </div>
          <span class="manual">{{ $t('plan.pricing.sub') }}</span>
      </div>
    </div>

    <span class="button-close" @click="onCloseLayer">
      <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'> <g fill='none' fill-rule='evenodd' stroke='#444' stroke-linecap='round' stroke-linejoin='round'> <path d='M3 3l10 10M13 3L3 13'/> </g> </svg>
    </span>
  </content-box>
</template>

<script>
import { normalPlans, normalPlanOptionList } from '@/libs/plan-helper'
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'
import UiTooltip from '@/components/ui/UiTooltip'
import browser from '@/libs/browser'

export default {
  components: {
    ContentBox,
    UiButton
  },
  props: [
    'planData'
  ],
  data () {
    return {
      popularPlan: 'Standard',
      planType: 'saas',
      // paymentType: 'card',
      browser: browser,
      saasDetail: 'Starter',
      saasPrice: this.$t('plan.pricing.saas.price[0]'),
      saasPlanNumber: 21,
      saasPv: [
        { value: 50000, label: this.$t('plan.pricing.saas.pv[0]') },
        { value: 100000, label: this.$t('plan.pricing.saas.pv[1]') },
        { value: 200000, label: this.$t('plan.pricing.saas.pv[2]') },
        { value: 300000, label: this.$t('plan.pricing.saas.pv[3]') },
        { value: 400000, label: this.$t('plan.pricing.saas.pv[4]') },
        { value: 500000, label: this.$t('plan.pricing.saas.pv[5]') }
      ],
      enterpriseDetail: 'Cloud 1M',
      enterprisePrice: this.$t('plan.pricing.enterprise.price[0]'),
      enterprisePlanNumber: 1001,
      enterprisePv: [
        { value: 1000000, label: this.$t('plan.pricing.enterprise.pv[0]') },
        { value: 2000000, label: this.$t('plan.pricing.enterprise.pv[1]') },
        { value: 3000000, label: this.$t('plan.pricing.enterprise.pv[2]') },
        { value: 4000000, label: this.$t('plan.pricing.enterprise.pv[3]') },
        { value: 5000000, label: this.$t('plan.pricing.enterprise.pv[4]') }
      ],
      selectOption: {
        saas: '50000',
        enterprise: '1000000'
      },
      isMac: false
    }
  },
  created () {
    this.normalPlans = normalPlans
    this.normalPlanOptionList = normalPlanOptionList
    this.isMac = navigator.platform.indexOf('Mac') > -1
  },
  methods: {
    onChangePvOption (event) {
      switch (event.target.value) {
        case '50000':
          this.saasDetail = 'Starter'
          this.saasPrice = this.$t('plan.pricing.saas.price[0]')
          this.saasPlanNumber = 21
          break
        case '100000':
          this.saasDetail = 'Basic'
          this.saasPrice = this.$t('plan.pricing.saas.price[1]')
          this.saasPlanNumber = 2
          break
        case '200000':
          this.saasDetail = 'Light'
          this.saasPrice = this.$t('plan.pricing.saas.price[2]')
          this.saasPlanNumber = 22
          break
        case '300000':
          this.saasDetail = 'Standard'
          this.saasPrice = this.$t('plan.pricing.saas.price[3]')
          this.saasPlanNumber = 3
          break
        case '400000':
          this.saasDetail = 'Premium'
          this.saasPrice = this.$t('plan.pricing.saas.price[4]')
          this.saasPlanNumber = 23
          break
        case '500000':
          this.saasDetail = 'Pro'
          this.saasPrice = this.$t('plan.pricing.saas.price[5]')
          this.saasPlanNumber = 4
          break
      }
    },
    onChangeEnterprisePvOption (event) {
      switch (event.target.value) {
        case '1000000':
          this.enterpriseDetail = 'Cloud 1M'
          this.enterprisePrice = this.$t('plan.pricing.enterprise.price[0]')
          this.enterprisePlanNumber = 1001
          break
        case '2000000':
          this.enterpriseDetail = 'Cloud 2M'
          this.enterprisePrice = this.$t('plan.pricing.enterprise.price[1]')
          this.enterprisePlanNumber = 1002
          break
        case '3000000':
          this.enterpriseDetail = 'Cloud 3M'
          this.enterprisePrice = this.$t('plan.pricing.enterprise.price[2]')
          this.enterprisePlanNumber = 1003
          break
        case '4000000':
          this.enterpriseDetail = 'Cloud 4M'
          this.enterprisePrice = this.$t('plan.pricing.enterprise.price[3]')
          this.enterprisePlanNumber = 1004
          break
        case '5000000':
          this.enterpriseDetail = 'Cloud 5M'
          this.enterprisePrice = this.$t('plan.pricing.enterprise.price[4]')
          this.enterprisePlanNumber = 1005
          break
      }
    },
    onSelectPlanType (value) {
      this.planType = value
    },
    onSelectPaymentType (value) {
      this.paymentType = value
    },
    canChangePlan (planNumber) {
      if (this.planData.isTrial && planNumber !== 0) {
        return true
      } else {
        return planNumber !== 0 && (this.planData.useCoupon || planNumber !== this.planData.planNumber)
      }
    },
    isInUsePlan (planNumber) {
      if (this.planData.useCoupon) {
        return false
      } else {
        return planNumber === this.planData.planNumber
      }
    },
    onSelectPlan (type, value) {
      if (this.canChangePlan(value)) {
        this.$emit('onNextPlan', value, type)
      }
    },
    onMouseEnter (value, enterprise) {
      let targetElements
      if (enterprise) {
        targetElements = document.querySelectorAll('.row__enterprise')
      } else {
        targetElements = document.querySelectorAll(`.row__${value}`)
      }
      for (let i = 0; i < targetElements.length; i++) {
        targetElements[i].classList.add('hover')
      }
    },
    onMouseLeave () {
      let targetElements = document.querySelectorAll('[class*=row__]')
      for (let i = 0; i < targetElements.length; i++) {
        targetElements[i].classList.remove('hover')
      }
    },
    onCloseLayer () {
      this.$emit('closeLayer')
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
html[lang='ko'] body {
  .template-pricing {
    word-break: keep-all;
    letter-spacing: -0.05em;

    .option-price {
      & /deep/ .small {
        position: relative;
        top: -2px;
        right: -2px;
      }
    }
  }
}

html[lang='en'] body {
  .template-pricing {
    word-break: keep-all;
  }
}

html[lang='ja'] body {
  .template-pricing {
    word-break: keep-all;
  }
}
.template-pricing {
  display: flex;
  justify-content: center;

  width: 100%;

  .english-font {
  }

  .contents {
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 100%;

    & > .options {
      display: flex;
      justify-content: center;
      align-items: center;
      column-gap: 30px;

      box-sizing: border-box;
      width: 100%;

      .option {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;

        width: 370px;
        height: 390px;
        padding: 15px;
        border-radius: 14px;
        box-shadow: 0 15px 15px -5px rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);

        transition: all 0.5s ease;

        .arrow-right {
          width: 18px;
          height: 18px;

          background: url(../../../assets/img/plan/icon-arrow-right.svg) no-repeat center center;
        }

        &.recommend {
          border: solid 4px #ec0047;
          margin: -4px;

          box-shadow: 0 15px 15px -5px rgba(0, 0, 0, 0.16);
        }

        &-recommend-image {
          position: absolute;
          top: 0;
          left: 0;

          background: url(../../../assets/img/plan/pricing-recommend.svg) no-repeat;
          width: 88px;
          height: 90px;

          &.en {
            background: url(../../../assets/img/new_plan_popular.svg) no-repeat;
          }

          &.ja {
            background: url(../../../assets/img/new_plan_popular.svg) no-repeat;
          }
        }

        &-title {
          position: relative;

          width: 100%;
          margin-top: 20px;

          font-size: 30px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: 1;
          letter-spacing: -0.5px;
          color: #333;
          text-align: center;

          .sub {
            display: block;
            position: absolute;
            top: 40px;

            width: 100%;

            font-size: 18px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: center;
            color: #0e99af;
            word-break: keep-all;
          }
        }

        &-main-image {
          margin-top: 30px;

          width: 184px;
          height: 108px;

          &.free {
            background: url(../../../assets/img/plan/free-trial.svg) no-repeat;
          }
          &.saas {
            background: url(../../../assets/img/plan/saas.svg) no-repeat;
          }
          &.enterprise {
            background: url(../../../assets/img/plan/enterprise.svg) no-repeat;
          }
        }

        &-pv {
          margin-top: 10px;
          padding: 10px 0px;

          font-size: 20px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: 1;
          letter-spacing: normal;
          text-align: center;
          color: #ec0047;
        }

        &-pv-select {
          margin-top: 10px;
          height: 40px;
          padding: 11px 36px 11px 12px;
          border-radius: 6px;
          border: solid 1px #b1b1b1;

          background: url(../../../assets//img/plan/icon-arrow-down.svg) no-repeat 92% 50%;
          font-size: 16px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: 1;
          letter-spacing: normal;
          color: #2f2f2f;

          appearance: none;
        }

        &-price {
          margin-top: 20px;

          font-size: 30px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.31;
          letter-spacing: -0.51px;
          color: #333;

          & /deep/ .small {
            font-size: 18px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.61;
            letter-spacing: -0.44px;
            color: #333;
          }
        }

        &-price-cancel {
          font-size: 18px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.61;
          letter-spacing: normal;
          color: #ec0047;
          text-decoration: line-through;
        }

        &-btn {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;

          width: 180px;
          height: auto;
          padding: 15px;
          border-radius: 25px;

          background-color: #ec0047;

          font-size: 18px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: 1;
          letter-spacing: normal;
          color: #fff;
          text-decoration: none;

          cursor: pointer;

          &:hover {
            background-color: #c60c3b;
          }

          .sale {
            position: absolute;
            top: -50%;
            right: -20px;
          }
        }

        &-spec {
          display: flex;
          flex-direction: column;

          .item-description {
            font-size: 15px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.7;
            letter-spacing: normal;
            color: #444;
            text-align: center;
          }

          .item-check-list {
            display: flex;
            flex-direction: column;
            row-gap: 6px;
          }

          .item-check {
            display: flex;
            align-items: center;
            padding-left: 25px;

            background: url(../../../assets/img/icon_check_green_size16.svg) no-repeat 0% 50%;

            font-size: 13px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.54;
            letter-spacing: normal;
            color: #444;
          }

          .item-detail {
            display: flex;
            justify-content: center;
            align-content: center;

            margin-top: 6px;

            font-size: 12.5px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: #888;
          }

          .item-info-list {
            display: flex;
            flex-direction: column;
            align-items: center;
            row-gap: 19px;

            .item {
              display: flex;
              align-items: center;
              justify-content: space-around;

              width: 306px;

              font-size: 13px;
              font-weight: 600;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.15;
              letter-spacing: normal;
              text-align: center;
              color: #444;

              &.special {
                color: #7e36e0;
              }

              hr {
                height: 2px;
                margin: 0px;
                border: none;
                border-top: 2px dotted #ccc;

                color: #fff;
                background-color: #fff;
              }

              .additional-info {
                position: relative;

                width: 15px;
                height: 15px;
                background: url('/images/icon-info.svg') no-repeat;
                background-size: cover;

                &:hover .info-bubble {
                  display: block;
                }

                .info-bubble {
                  display: none;
                  position: absolute;
                  right: -45px;
                  bottom: 25px;

                  box-sizing: border-box;
                  padding: 16px;
                  border-radius: 10px;

                  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
                  background-color: #fff;
                  font-size: 13px;
                  font-weight: 500;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: 1.46;
                  letter-spacing: normal;
                  text-align: start;
                  color: #767676;

                  z-index: 10;
                  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);

                  &::after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    right: 46px;
                    width: 0;
                    height: 0;
                    border: 7px solid transparent;
                    border-top-color: #fff;
                    border-bottom: 0;
                    margin-bottom: -7px;
                  }

                  .pro-only {
                    width: 55px;
                    margin-bottom: 6px;
                    padding: 4px 5px;
                    border-radius: 4px;
                    background-color: #7e36e0;
                    font-family: NewRubrik;
                    font-size: 9px;
                    font-weight: 600;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #fff;
                    text-align: center;
                  }
                }
              }
            }
          }
        }
      }
    }

    & > .manual {
      margin: 40px 0px 20px 0px;
      font-size: 13px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.61;
      letter-spacing: normal;
      text-align: center;
      color: #666;
    }
  }
}
.plan-subscription--wrap {
  padding: 30px 30px 61px;
  box-sizing: border-box;
  position: relative;
  background-color: #ffffff;
  transition: background-color 0.2s ease;
  color: #444444;

  .button-close {
    position: absolute;
    padding: 12px;
    top: 0px;
    right: 0px;
    background-position: center;
    border-radius: 100px;
    background-color: transparent;
    cursor: pointer;
    transition: transform .3s;

    svg {
      g {
        stroke: #444444;
        transition: stroke 0.2s ease;
      }
    }

    &:hover {
      transform: scale(1.3);
    }
  }
  .title {
    font-size: 20px;
    font-weight: 600;
    color: #444444;
    transition: color 0.2s ease;
  }
  .desc {
    font-size: 13px;
    color: #444444;
    margin-top: 12px;
    margin-bottom: 41px;
    transition: color 0.2s ease;
  }
  .scrollable {
    overflow: visible;
    max-height: 562px;
  }

  .plan-type--wrap {
    @include positionXcenter;
    top: 30px;

    .plan-type {
      border: 1px solid #e0e0e0;
      background-color: #ffffff;
      transition: background-color 0.3s ease, border-color 0.3s ease;
      border-radius: 20px;
      position: relative;

      button {
        width: 125px;
        text-align: center;
        line-height: 36px;
        height: 36px;
        color: #888888;
        position: relative;
        font-size: 14px;
        z-index: 2;
        transition: color 0.3s ease;

        &:first-child {
          box-sizing: border-box;
          padding-left: 3px;
        }

        &:last-child {
          box-sizing: border-box;
          padding-right: 3px;
        }

        i {
          vertical-align: middle;
          transform: translateY(-1px);
          width: 0;
          transition: width 0.3s ease, margin 0.3s ease;
        }

        &.on {
          color: #ffffff;

          i {
            width: 20px;
            margin: 0 -5px 0 5px;
          }
        }
      }

      &::before {
        content: "";
        position: absolute;
        z-index: 1;
        top: -1px;
        left: -1px;
        background: #ec0147;
        border-radius: 20px;
        transition: left 0.3s cubic-bezier(0.25, 1, 0.5, 1);
        display: block;
        width: 131px;
        height: 38px;
        box-shadow: 0 12px 10px -4px rgba(0, 0, 0, 0.25);
      }

      &.enterprise::before {
        left: 120px;
      }
    }
  }

  .plan-list--wrap {
    .vat {
      color: #444444;
      font-size: 13px;
      text-align: right;
      margin-right: 60px;
      margin-bottom: 10px;
      transition: color 0.2s ease;
    }

    .plan-list {
      position: relative;
      margin: 0 30px;
      height: 562px;

      .features {
        position: absolute;
        top: 240px;
        left: -1px;
        width: calc(100% + 1px);
        height: 225px;
        background-color: #f5f5f5;
        border-top: 1px solid #d8d8d8;
        border-bottom: 1px solid #d8d8d8;
        transition: border-color 0.2s ease, background-color 0.2s ease;
        z-index: 2;

        h5 {
          float: left;
          width: 205px;
          padding-top: 38px;
          margin-left: 60px;
          font-size: 14px;
          font-weight: 600;
          color: #1199af;

          & /deep/ span {
            display: inline-block;
            font-size: 12px;
            transform: translateY(-1px);
          }

          &::after {
            content: "";
            display: inline-block;
            width: 12px;
            height: 12px;
            background-image: url(../../../assets/img/icon_arrow_triangle_green_size12.svg);
            vertical-align: middle;
            margin-left: 5px;
            transform: translateY(-1px);
          }
        }

        ul {
          float: left;
          width: 419px;
          padding-top: 27px;

          &:last-child {
            width: 216px;
          }

          li {
            position: relative;
            margin-left: 17px;
            font-size: 13px;
            line-height: 1.2;
            margin: 11px 10px;

            &::before {
              content: "";
              position: absolute;
              top: 6px;
              left: -17px;
              display: block;
              width: 3px;
              height: 3px;
              background-color: #aaaaaa;
            }
          }
        }

        &::after {
          content: "";
          position: absolute;
          bottom: -5px;
          left: 0;
          width: 100%;
          height: 5px;
          background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0));
        }
      }

      .plans {
        white-space: nowrap;

        .plan {
          float: left;
          width: 136px;
          text-align: center;
          padding: 15px 0;
          margin-left: -1px;
          transition: color 0.2s ease, box-shadow 0.2s ease;
          border-radius: 8px;
          cursor: default;

          &.trial {
            color: #1199af;
          }

          .name {
            border-left: 1px solid;
            border-color: #d8d8d8;
            transition: border-color 0.2s ease;
            padding-bottom: 25px;
            height: 92px;

            i {
              margin-top: 15px;
              margin-bottom: 10px;
            }

            h6 {
              font-weight: 600;
              font-size: 18px;
            }
          }

          .price {
            border-left: 1px solid;
            border-color: #d8d8d8;
            transition: border-color 0.2s ease;
            padding: 15px 0;
            font-size: 13px;
            font-weight: 600;
            height: 27px;

            & /deep/ span {
              font-size: 27px;
            }
          }

          .feature {
            border-left: 1px solid;
            border-color: #d8d8d8;
            transition: border-color 0.2s ease;
            padding: 15px 0;
            font-size: 14px;
            font-weight: 600;
            height: 255px;

            li {
              margin: 10px;
              line-height: 1.25;
              display: block;
              white-space: normal;
            }

            span /deep/ span {
              font-size: 12px;
            }

            span /deep/ i.icon {
              transform: translateY(1px);
            }

            .more {
              display: inline-block;
              transform: translateY(-2px);
              margin: 0 5px;
              position: relative;
              z-index: 1;

              .icon {
                vertical-align: middle;
                margin-left: 3px;
              }

              .bubble {
                @include positionXcenter;
                bottom: 27px;
                display: none;
                padding: 16px 20px;

                &.right {
                  left: auto;
                  right: -11px;
                  transform: none;
                }

                & /deep/ .text {
                  text-align: left;

                  & h6 {
                    color: #a1720c;
                    font-weight: 600;
                    font-size: 14px;

                    span {
                      display: none;
                    }
                  }

                  ul {
                    margin: 20px 10px -5px 10px;

                    li {
                      position: relative;
                      margin-left: 17px;
                      font-size: 13px;
                      line-height: 1.2;
                      margin: 11px 0 11px 10px;
                      white-space: nowrap;

                      &::before {
                        content: "";
                        position: absolute;
                        top: 6px;
                        left: -17px;
                        display: block;
                        width: 3px;
                        height: 3px;
                        background-color: #aaaaaa;
                      }
                    }
                  }

                  p {
                    color: #ec0147;
                    line-height: 1.62;
                    font-size: 13px;
                    margin-top: 14px;
                    padding-right: 15px;
                    white-space: nowrap;
                  }

                  ul + p {
                    border-top: dashed 1px #c1c1c1;
                    padding-top: 12px;
                    margin-top: 22px;
                  }
                }
              }

              &:hover {
                z-index: 2;
                .bubble {
                  display: block;
                }
              }
            }
          }

          .pv {
            border-left: 1px solid;
            border-color: #d8d8d8;
            transition: border-color 0.2s ease;
            color: #ec0047;
            font-size: 12px;
            font-weight: 600;
            height: 50px;

            span {
              font-size: 18px;
            }

            p.description {
              color: #767676;
              font-size: 12px;
              padding: 5px 0 15px 0;
              font-weight: normal;
            }
          }

          .button {
            border-left: 1px solid;
            border-color: #d8d8d8;
            transition: border-left-color 0.2s ease;
            padding: 243px 0 3px 0;
            height: 38px;

            button {
              min-width: 90px;
              border: none;
            }
          }

          &.popular {
            margin: 0 3px 0 2px;
            &::before {
              content: "POPULAR";
              color: transparent;
              display: block;
              position: absolute;
              top: 0;
              left: 0;
              width: 83px;
              height: 79px;
              background-image: url(../../../assets/img/new_plan_popular.svg);
            }

            .button {
              button {
                transition: background 0.2s ease;
                & /deep/ span {
                  transition: color 0.2s ease;
                }
              }
            }
          }

          &.popular:not(:hover) {
            position: relative;
            z-index: 1;
            background-image: linear-gradient(168deg, #fc225a 5%, #af0137 77%);
            color: #ffffff;

            .pv {
              color: #ffee4b;

              p.description {
                color: #ffee4b;
              }
            }

            .button {
              button {
                background-color: #ffffff;
                box-shadow: 0 11px 8px -3px rgba(0, 0, 0, 0.23), 0 1px 3px 0 rgba(0, 0, 0, 0.06);

                & /deep/ span {
                  color: #FC004E;
                }
              }
            }
          }

          &:hover {
            position: relative;
            z-index: 1;
            box-shadow: inset 0 0 0 2px rgb(252, 0, 7), inset 0 1px 7px 0 rgba(67, 7, 23, 0.78);
            background-color: #fdf6f6;
          }

          &.premium,
          &.popular,
          &:hover,
          &:first-child {
            .name {
              border-left-color: transparent !important;
            }
            .price {
              border-left-color: transparent !important;
            }
            .feature {
              border-left-color: transparent !important;
            }
            .pv {
              border-left-color: transparent !important;
            }
            .button {
              border-left-color: transparent !important;
            }
          }
        }
      }
    }
  }

  .arrow--wrap {
    button {
      @include positionYcenter;
      right: -25px;
      width: 50px;
      height: 50px;
      box-shadow: 0 8px 12px -8px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(0, 0, 0, 0.16);
      background-color: #ffffff;
      border-radius: 50px;
      transition: background-color 0.2s ease;
      z-index: 1;
    }
  }

  &.enterprise {
    color: #ffffff;
    background-color: #141414;

    .button-close {
      svg {
        g {
          stroke: #888888;
        }
      }
    }
    .title {
      color: #ffffff;
    }
    .desc {
      color: #888888;
    }

    .plan-type--wrap {
      .plan-type {
        border-color: #333333;
        background-color: #303030;
      }
    }

    .plan-list--wrap {
      .vat {
        color: #888888;
      }

      .plan-list {
        .features {
          background-color: #303030;
          border-top-color: #47371a;
          border-bottom-color: #47371a;
        }

        .plans {
          .plan {
            width: 320px;
            .name {
              border-color: #47371a;
              padding: 20px 0;
              height: auto;
              h6 {
                color: #f3c052;
                font-size: 21px;
                font-weight: 600;
              }
            }

            .price {
              border-color: #47371a;
              font-size: 24px;
              font-weight: 600;
            }

            .pv {
              border-color: #47371a;
              font-size: 20px;
              font-weight: 600;
              height: 45px;

              .description {
                font-size: 13px;
                color: #ec0147;
                margin-top: 5px;
              }
            }

            .feature {
              border-color: #47371a;
            }

            .button {
              border-color: #47371a;
              padding-top: 0;
              padding-bottom: 25px;

              button {
                width: 160px;
              }
            }

            &:hover {
              background-color: rgba(236, 0, 71, 0.05);
            }
          }
        }
      }
    }

    .arrow--wrap {
      button {
        right: auto;
        left: -25px;
        background-color: #2f2f2f;

        i {
          transform: scaleX(-1);
        }
      }
    }
  }
}
</style>
